import styled from "styled-components";
import useTranslation from "../../hooks/useTranslation";

const Container = ({ children, className = "", ...rest }) => {
  const { language } = useTranslation();

  return (
    <StyledContainer
      language={language}
      dir={language === "ar" ? "rtl" : "ltr"}
      className={className}
      {...rest}
    >
      {children}
    </StyledContainer>
  );
};

export default Container;

const StyledContainer = styled.div`
  * {
    font-family: ${(props) =>
      props.language === "en" ? "Poppins" : "Almarai"};
  }

  width: calc(1248 / 1440 * 100vw);
  margin: 0 auto;
  padding-top: calc(30 / 1440 * 100vw);
  padding-bottom: calc(30 / 1440 * 100vw);

  @media (max-width: 768px) {
    width: 100%;
    padding: calc(16 / 375 * 100vw);
  }
`;
